import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';
import stylePropType from 'react-style-proptype';

import { Card, CardText, CardTitle } from 'react-md';
import { round } from 'lodash';

import './DashboardCard.scss';

const themes = ['white', 'red', 'blue', 'green', 'orange', 'yellow', 'purple', 'grey'];

class DashboardCard extends React.PureComponent {
  handleRoute = ({ route, query }) => {
    const { onRoute } = this.props;
    onRoute({ route, query });
  };

  render() {
    const { style, theme, title, subtitle, data, roundingPrecision, strings } = this.props;
    const roundNum = num => round(num, roundingPrecision);

    const rows = (
      <div className="rows">
        {data.map(({ value, label, route, query }) => (
          <div
            className={cn('row', {
              large: data.length === 1,
              medium: data.length === 2,
              small: data.length >= 3,
            })}
            onClick={() => this.handleRoute({ route, query })}
            key={`${value}${strings[label] || label}${route}`}
            onKeyPress={() => this.handleRoute({ route, query })}
            role="link"
            tabIndex={0}
          >
            <span className="value">{roundNum(value)}</span>
            <span className="label">{strings[label] || label}</span>
          </div>
        ))}
      </div>
    );

    return (
      <Card style={style} className={`dashboard-card ${theme}`}>
        <CardTitle title={strings[title] || title} subtitle={strings[subtitle] || subtitle} />
        <CardText>{rows}</CardText>
      </Card>
    );
  }
}

DashboardCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string),
  style: stylePropType,
  theme: PropTypes.oneOf(themes),
  roundingPrecision: PropTypes.oneOf(['0', '1', '2']),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.const,
      route: PropTypes.string, // should be a route,
      query: PropTypes.string, // should be a query
    })
  ),
  onRoute: PropTypes.func,
};

DashboardCard.defaultProps = {
  subtitle: '',
  theme: 'red',
  strings: {},
  style: { minWidth: '250px' },
  data: [],
  roundingPrecision: '0',
  onRoute: val => {
    console.log('onRoute::', val); /* eslint-disable-line no-console */
  },
};

export default DashboardCard;
